import React, { Component } from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import { Spinner as Spinjs } from 'spin.js';

const SPINNER_CONFIG = {
    lines: 8,
    width: 3,
    opacity: 0,
    scale: 0.4,
    top: '9px',
};

export default class Spinner extends Component {
    static displayName = displayName('LoadingIndicator/Spinner');

    static propTypes = {
        white: PropTypes.bool,
    };

    static defaultProps = {
        white: false,
    };

    componentDidMount() {
        this.setupSpinner();
    }

    componentDidUpdate() {
        this.setupSpinner();
    }

    setupSpinner() {
        if (this.spinner && !this.isSpinnerSetUp) {
            const { white } = this.props;

            const spinnerConfig = { ...SPINNER_CONFIG };

            if (white) {
                spinnerConfig.color = '#fff';
            }

            new Spinjs(spinnerConfig).spin(this.spinner);

            this.isSpinnerSetUp = true;
        }
    }

    isSpinnerSetUp = false;

    render() {
        return <data ref={(_r) => { this.spinner = _r; }} />;
    }
}
